document.addEventListener("DOMContentLoaded", function () {

    const options = {
        root: null,
        rootMargin: "100px",
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {
        if (entry.isIntersecting) {
            const section = entry.target;

            // Reveal the section content
            section.classList.remove("deferred-hidden");
            section.classList.add("deferred-loaded");

            // Add ARIA live announcement if needed
            section.setAttribute("aria-live", "polite");

            // Stop observing once the content is loaded
            observer.unobserve(section);
        }
        });
    }, options);

    const deferredSections = document.querySelectorAll("section[data-deferred-section]");

    deferredSections.forEach(section => {
        observer.observe(section);
    });
});
